export default {
  loading: state => state.loading,
  getQuestion: state => state.question,
  getQuestionType: state => state.questionType,
  getIsFromBiometry: state => state.isFromBiometry,
  getSkipBiometry: state => state.skipBiometry,
  getOrderDate: state => state.orderDate,
  getOrderCode: state => state.orderCode,
  getUuidBiometry: state => state.uuidBiometry,
  getUuidOrder: state => state.uuidOrder,
  getToken: state => state.token
}
